import { LinkPlugin } from '@lexical/react/LexicalLinkPlugin';

import { ClickableLinkPlugin } from './ClickableLinkPlugin';
import { UrlAutoLinkPlugin } from './UrlAutoLinkPlugin';

/** Link editing (toolbar `LinkControl`), URL auto-detection, and opening links on click. */
export const LinksPlugin = () => (
  <>
    <LinkPlugin />
    <UrlAutoLinkPlugin />
    <ClickableLinkPlugin />
  </>
);
